module.exports = function getItemPoint(el) {
	var d = el.dataset;
	
	return {
		el: el,
		lat: d.lat,
		lng: d.lng,
		img: d.img,
		name: d.name,
		color: d.color,
		regions: d.regions ? JSON.parse(d.regions) : null
	};
};


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/contacts/fn/getItemPoint.js
 **/